var opt = {
    autoWidth: false,
    responsive: true,
    dom: '<"data-table__header"lf>rt<"data-table__footer"ip>',
    lengthMenu: [[10, 25, 50, 100, 200, -1], [10, 25, 50, 100, 200, "همه"]],
    order: [[ 1, "desc" ]],
    columnDefs: [{
        targets: "_all",
        orderable: true,
        type: 'pstring'
    }],
    language: {
        "decimal": "",
        "emptyTable": "نتیجهی یافت نشد",
        "info": "نمایش _START_ تا _END_ از _TOTAL_ نتیجه",
        "infoEmpty": "نمایش 0 تا 0 از 0 نتیجه",
        "infoFiltered": "(فیلتر شده از _MAX_ نتیجه)",
        "infoPostFix": "",
        "thousands": ",",
        "lengthMenu": " _MENU_",
        "loadingRecords": "در حال بارگذاری...",
        "processing": "در حال پردازش...",
        "search": "",
        "searchPlaceholder": "جستجو ...",
        "zeroRecords": "نتیجه ای پیدا نشد",
        "paginate": {
            "first": "اول",
            "last": "آخر",
            "next": "بعدی",
            "previous": "قبلی"
        },
        "aria": {
            "sortAscending": ": activate to sort column ascending",
            "sortDescending": ": activate to sort column descending"
        }
    }
};

var data_table = $('.data-table').DataTable(opt);
